module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a7-5-26cc01745a6ad4f4cf63c1310d6c2425.jpg";